import {css} from 'lit';

export const packageReviewsStyles = css`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.layout {
  flex-wrap: wrap;
  margin: 0 0 0 -20px;
  padding: 0;
  list-style: none;
  display: flex;
}

@media screen and (width >= 47em), print {
  .layout--nowrap {
    flex-wrap: nowrap;
  }
}

.layout--rev {
  flex-direction: row-reverse;
}

.layout--middle {
  align-items: center;
}

.layout--spaced {
  justify-content: space-between;
}

.layout--center {
  justify-content: center;
}

.layout__item {
  width: 100%;
  padding-left: 20px;
}

.layout--auto > .layout__item {
  flex-basis: content;
}

.layout--flush {
  margin-left: 0;
}

.layout--flush > .layout__item {
  padding-left: 0;
}

.layout--small {
  margin-left: -10px;
}

.layout--small > .layout__item {
  padding-left: 10px;
}

.c-button {
  --button-background-color: var(--color-brand);
  --button-text-color: var(--color-white);
  font-size: var(--font-size-button);
  line-height: var(--line-height-button);
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  color: var(--button-text-color);
  background-color: var(--button-background-color);
  border-radius: var(--border-radius-m);
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border: none;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  display: inline-flex;
  position: relative;
  overflow: hidden;
  transform: translateZ(0);
}

.c-button:not(.c-icon-button) {
  padding: calc(1.5 * var(--spacing-)) var(--spacing);
}

.c-button:hover {
  text-decoration: none;
}

.c-button[hidden] {
  display: none;
}

.c-button:before {
  content: "";
  z-index: -1;
  background: var(--color-black);
  opacity: 0;
  transform-origin: 50%;
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border-radius: var(--button-border-radius);
  position: absolute;
  inset: 0;
  transform: scale(.5);
}

.c-button:hover:before, .c-button:active:before {
  opacity: .15;
  transform: scale(1.2);
}

.c-button--small {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  border-radius: var(--border-radius-s);
  padding-top: var(--spacing-) !important;
  padding-bottom: var(--spacing-) !important;
}

.c-button--large {
  padding-top: var(--spacing) !important;
  padding-bottom: var(--spacing) !important;
}

.c-button--support {
  --button-background-color: var(--color-brand--support);
  --button-text-color: var(--color-white);
}

.c-button--accent {
  --button-background-color: var(--color-brand--accent);
  --button-text-color: var(--color-white);
}

.c-button--grey {
  --button-background-color: var(--color-grey--light);
  --button-text-color: var(--color-grey--dark);
}

.c-button--white {
  --button-background-color: var(--color-white);
  --button-text-color: var(--color-grey--dark);
  fill: var(--color-grey--dark);
}

.c-button--white:before {
  background-color: #0000;
}

.c-button--white:hover {
  background-color: hsl(from var(--color-white) h s l / .9);
}

.c-button--ghost {
  --button-background-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-color: inherit;
}

.c-button--ghost:before {
  background-color: var(--color-white);
}

.c-button--disabled, .c-button[disabled] {
  cursor: default;
  --button-background-color: var(--color-grey--light);
}

.c-button--disabled:before, .c-button[disabled]:before {
  display: none;
}

.c-button--fullwidth {
  width: 100%;
}

.c-spec {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h3);
  font-family: var(--spec-face);
  font-style: normal;
}

@media screen and (width <= 46.9375em) {
  .c-spec {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }
}

.c-spec--amount {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

@media screen and (width <= 46.9375em) {
  .c-spec--amount {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

.c-spec__decimals {
  vertical-align: super;
  margin-left: 2px;
  font-size: .6em;
  line-height: 1;
  position: relative;
  top: .1em;
}

.c-spec--rating {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

@media screen and (width <= 46.9375em) {
  .c-spec--rating {
    font-size: var(--font-size-m);
    line-height: var(--line-height-l);
  }
}

.c-spec--rating-tab {
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  line-height: 1;
}

.c-spec--rating-tab .c-spec__decimals {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  margin-left: 1px;
  top: .2em;
}

.c-star-rating {
  width: 100px;
  height: 18px;
  position: relative;
}

.c-star-rating--small {
  transform-origin: 0;
  transform: scale(.8);
}

.c-star-rating__empty {
  background: url("data:image/svg+xml,<svg width=\\"20\\" height=\\"18\\" viewBox=\\"0 0 20 18\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M9.842 14.925L3.936 18l1.128-6.512L.286 6.875l6.603-.95L9.842 0l2.953 5.925 6.603.95-4.778 4.613L15.748 18z\\" fill=\\"%23D5D5D5\\" fill-rule=\\"evenodd\\"/></svg>") 0 repeat-x;
  display: block;
  position: absolute;
  inset: 0;
}

.c-star-rating__full {
  background: url("data:image/svg+xml,<svg width=\\"20\\" height=\\"18\\" viewBox=\\"0 0 20 18\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M9.842 14.925L3.936 18l1.128-6.512L.286 6.875l6.603-.95L9.842 0l2.953 5.925 6.603.95-4.778 4.613L15.748 18z\\" fill=\\"%23FAD43A\\" fill-rule=\\"evenodd\\"/></svg>") 0 repeat-x;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}

.c-link {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  cursor: pointer;
  font-weight: bold;
  display: inline-block;
}

.c-link--accent {
  color: var(--color-brand--accent);
}

.c-link--accent:hover {
  color: var(--color-brand--support);
  text-decoration: none;
}

.c-link--underline {
  font-weight: normal;
  text-decoration: underline;
}

.c-link--underline:hover {
  text-decoration: none;
}

.m0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mr0 {
  margin-right: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml0 {
  margin-left: 0 !important;
}

.mv0 {
  margin-block: 0 !important;
}

.mh0 {
  margin-inline: 0 !important;
}

.m-- {
  margin: .313rem !important;
}

.mt-- {
  margin-top: .313rem !important;
}

.mr-- {
  margin-right: .313rem !important;
}

.mb-- {
  margin-bottom: .313rem !important;
}

.ml-- {
  margin-left: .313rem !important;
}

.mv-- {
  margin-block: .313rem !important;
}

.mh-- {
  margin-inline: .313rem !important;
}

.m- {
  margin: .625rem !important;
}

.mt- {
  margin-top: .625rem !important;
}

.mr- {
  margin-right: .625rem !important;
}

.mb- {
  margin-bottom: .625rem !important;
}

.ml- {
  margin-left: .625rem !important;
}

.mv- {
  margin-block: .625rem !important;
}

.mh- {
  margin-inline: .625rem !important;
}

.m {
  margin: 1.25rem !important;
}

.mt {
  margin-top: 1.25rem !important;
}

.mr {
  margin-right: 1.25rem !important;
}

.mb {
  margin-bottom: 1.25rem !important;
}

.ml {
  margin-left: 1.25rem !important;
}

.mv {
  margin-block: 1.25rem !important;
}

.mh {
  margin-inline: 1.25rem !important;
}

.m\\+ {
  margin: 2.5rem !important;
}

.mt\\+ {
  margin-top: 2.5rem !important;
}

.mr\\+ {
  margin-right: 2.5rem !important;
}

.mb\\+ {
  margin-bottom: 2.5rem !important;
}

.ml\\+ {
  margin-left: 2.5rem !important;
}

.mv\\+ {
  margin-block: 2.5rem !important;
}

.mh\\+ {
  margin-inline: 2.5rem !important;
}

.m\\+\\+ {
  margin: 5rem !important;
}

.mt\\+\\+ {
  margin-top: 5rem !important;
}

.mr\\+\\+ {
  margin-right: 5rem !important;
}

.mb\\+\\+ {
  margin-bottom: 5rem !important;
}

.ml\\+\\+ {
  margin-left: 5rem !important;
}

.mv\\+\\+ {
  margin-block: 5rem !important;
}

.mh\\+\\+ {
  margin-inline: 5rem !important;
}

.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pb0 {
  padding-bottom: 0 !important;
}

.pl0 {
  padding-left: 0 !important;
}

.pv0 {
  padding-block: 0 !important;
}

.ph0 {
  padding-inline: 0 !important;
}

.p-- {
  padding: .313rem !important;
}

.pt-- {
  padding-top: .313rem !important;
}

.pr-- {
  padding-right: .313rem !important;
}

.pb-- {
  padding-bottom: .313rem !important;
}

.pl-- {
  padding-left: .313rem !important;
}

.pv-- {
  padding-block: .313rem !important;
}

.ph-- {
  padding-inline: .313rem !important;
}

.p- {
  padding: .625rem !important;
}

.pt- {
  padding-top: .625rem !important;
}

.pr- {
  padding-right: .625rem !important;
}

.pb- {
  padding-bottom: .625rem !important;
}

.pl- {
  padding-left: .625rem !important;
}

.pv- {
  padding-block: .625rem !important;
}

.ph- {
  padding-inline: .625rem !important;
}

.p {
  padding: 1.25rem !important;
}

.pt {
  padding-top: 1.25rem !important;
}

.pr {
  padding-right: 1.25rem !important;
}

.pb {
  padding-bottom: 1.25rem !important;
}

.pl {
  padding-left: 1.25rem !important;
}

.pv {
  padding-block: 1.25rem !important;
}

.ph {
  padding-inline: 1.25rem !important;
}

.p\\+ {
  padding: 2.5rem !important;
}

.pt\\+ {
  padding-top: 2.5rem !important;
}

.pr\\+ {
  padding-right: 2.5rem !important;
}

.pb\\+ {
  padding-bottom: 2.5rem !important;
}

.pl\\+ {
  padding-left: 2.5rem !important;
}

.pv\\+ {
  padding-block: 2.5rem !important;
}

.ph\\+ {
  padding-inline: 2.5rem !important;
}

.p\\+\\+ {
  padding: 5rem !important;
}

.pt\\+\\+ {
  padding-top: 5rem !important;
}

.pr\\+\\+ {
  padding-right: 5rem !important;
}

.pb\\+\\+ {
  padding-bottom: 5rem !important;
}

.pl\\+\\+ {
  padding-left: 5rem !important;
}

.pv\\+\\+ {
  padding-block: 5rem !important;
}

.ph\\+\\+ {
  padding-inline: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .m0\\(s\\) {
    margin: 0 !important;
  }

  .mt0\\(s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(s\\) {
    margin: .313rem !important;
  }

  .mt--\\(s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(s\\) {
    margin: .625rem !important;
  }

  .mt-\\(s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(s\\) {
    padding: 0 !important;
  }

  .pt0\\(s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(s\\) {
    padding: .313rem !important;
  }

  .pt--\\(s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(s\\) {
    padding: .625rem !important;
  }

  .pt-\\(s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .m0\\(m\\) {
    margin: 0 !important;
  }

  .mt0\\(m\\) {
    margin-top: 0 !important;
  }

  .mr0\\(m\\) {
    margin-right: 0 !important;
  }

  .mb0\\(m\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(m\\) {
    margin-left: 0 !important;
  }

  .mv0\\(m\\) {
    margin-block: 0 !important;
  }

  .mh0\\(m\\) {
    margin-inline: 0 !important;
  }

  .m--\\(m\\) {
    margin: .313rem !important;
  }

  .mt--\\(m\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(m\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(m\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(m\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(m\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(m\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(m\\) {
    margin: .625rem !important;
  }

  .mt-\\(m\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(m\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(m\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(m\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(m\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(m\\) {
    margin-inline: .625rem !important;
  }

  .m\\(m\\) {
    margin: 1.25rem !important;
  }

  .mt\\(m\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(m\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(m\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(m\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(m\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(m\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(m\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(m\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(m\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(m\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(m\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(m\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(m\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(m\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(m\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(m\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(m\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(m\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(m\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(m\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(m\\) {
    padding: 0 !important;
  }

  .pt0\\(m\\) {
    padding-top: 0 !important;
  }

  .pr0\\(m\\) {
    padding-right: 0 !important;
  }

  .pb0\\(m\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(m\\) {
    padding-left: 0 !important;
  }

  .pv0\\(m\\) {
    padding-block: 0 !important;
  }

  .ph0\\(m\\) {
    padding-inline: 0 !important;
  }

  .p--\\(m\\) {
    padding: .313rem !important;
  }

  .pt--\\(m\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(m\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(m\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(m\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(m\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(m\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(m\\) {
    padding: .625rem !important;
  }

  .pt-\\(m\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(m\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(m\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(m\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(m\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(m\\) {
    padding-inline: .625rem !important;
  }

  .p\\(m\\) {
    padding: 1.25rem !important;
  }

  .pt\\(m\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(m\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(m\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(m\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(m\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(m\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(m\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(m\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(m\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(m\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(m\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(m\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(m\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(m\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(m\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(m\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(m\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(m\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(m\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(m\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .m0\\(\\!s\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!s\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!s\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!s\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!s\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!s\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .m0\\(\\!l\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!l\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!l\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!l\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!l\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!l\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .m0\\(l\\) {
    margin: 0 !important;
  }

  .mt0\\(l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(l\\) {
    margin: .313rem !important;
  }

  .mt--\\(l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(l\\) {
    margin: .625rem !important;
  }

  .mt-\\(l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(l\\) {
    padding: 0 !important;
  }

  .pt0\\(l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(l\\) {
    padding: .313rem !important;
  }

  .pt--\\(l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(l\\) {
    padding: .625rem !important;
  }

  .pt-\\(l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .m0\\(xl\\) {
    margin: 0 !important;
  }

  .mt0\\(xl\\) {
    margin-top: 0 !important;
  }

  .mr0\\(xl\\) {
    margin-right: 0 !important;
  }

  .mb0\\(xl\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(xl\\) {
    margin-left: 0 !important;
  }

  .mv0\\(xl\\) {
    margin-block: 0 !important;
  }

  .mh0\\(xl\\) {
    margin-inline: 0 !important;
  }

  .m--\\(xl\\) {
    margin: .313rem !important;
  }

  .mt--\\(xl\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(xl\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(xl\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(xl\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(xl\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(xl\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(xl\\) {
    margin: .625rem !important;
  }

  .mt-\\(xl\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(xl\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(xl\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(xl\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(xl\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(xl\\) {
    margin-inline: .625rem !important;
  }

  .m\\(xl\\) {
    margin: 1.25rem !important;
  }

  .mt\\(xl\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(xl\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(xl\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(xl\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(xl\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(xl\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(xl\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(xl\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(xl\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(xl\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(xl\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(xl\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(xl\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(xl\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(xl\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(xl\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(xl\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(xl\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(xl\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(xl\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(xl\\) {
    padding: 0 !important;
  }

  .pt0\\(xl\\) {
    padding-top: 0 !important;
  }

  .pr0\\(xl\\) {
    padding-right: 0 !important;
  }

  .pb0\\(xl\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(xl\\) {
    padding-left: 0 !important;
  }

  .pv0\\(xl\\) {
    padding-block: 0 !important;
  }

  .ph0\\(xl\\) {
    padding-inline: 0 !important;
  }

  .p--\\(xl\\) {
    padding: .313rem !important;
  }

  .pt--\\(xl\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(xl\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(xl\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(xl\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(xl\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(xl\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(xl\\) {
    padding: .625rem !important;
  }

  .pt-\\(xl\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(xl\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(xl\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(xl\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(xl\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(xl\\) {
    padding-inline: .625rem !important;
  }

  .p\\(xl\\) {
    padding: 1.25rem !important;
  }

  .pt\\(xl\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(xl\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(xl\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(xl\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(xl\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(xl\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(xl\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(xl\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(xl\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(xl\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(xl\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(xl\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(xl\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(xl\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(xl\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(xl\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(xl\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(xl\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(xl\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(xl\\) {
    padding-inline: 5rem !important;
  }
}

.u-gap0 {
  gap: 0 !important;
}

.u-gap-- {
  gap: .313rem !important;
}

.u-gap- {
  gap: .625rem !important;
}

.u-gap {
  gap: 1.25rem !important;
}

.u-gap\\+ {
  gap: 2.5rem !important;
}

.u-gap\\+\\+ {
  gap: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .u-gap0\\(s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-gap0\\(m\\) {
    gap: 0 !important;
  }

  .u-gap--\\(m\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(m\\) {
    gap: .625rem !important;
  }

  .u-gap\\(m\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(m\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(m\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .u-gap0\\(\\!s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-gap0\\(\\!l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .u-gap0\\(l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-gap0\\(xl\\) {
    gap: 0 !important;
  }

  .u-gap--\\(xl\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(xl\\) {
    gap: .625rem !important;
  }

  .u-gap\\(xl\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(xl\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(xl\\) {
    gap: 5rem !important;
  }
}

.u-border {
  border: 1px solid var(--color-grey--light);
}

.u-border--left {
  border-left: 1px solid var(--color-grey--light);
}

.u-border--right {
  border-right: 1px solid var(--color-grey--light);
}

.u-border--top {
  border-top: 1px solid var(--color-grey--light);
}

.u-border--bottom {
  border-bottom: 1px solid var(--color-grey--light);
}

.u-border-radius-none {
  border-radius: var(--border-radius-none);
}

.u-border-radius-xs {
  border-radius: var(--border-radius-xs);
}

.u-border-radius-s {
  border-radius: var(--border-radius-s);
}

.u-border-radius, .u-border-radius-m {
  border-radius: var(--border-radius-m);
}

.u-border-radius-l {
  border-radius: var(--border-radius-l);
}

.u-border-radius-xl {
  border-radius: var(--border-radius-xl);
}

.u-border-radius--left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.u-border-radius--right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.u-border-radius--top {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.u-border-radius--bottom {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.u-text-color-white {
  color: var(--color-white--base);
}

.u-bg-color-white {
  background-color: var(--color-white--base);
}

.u-text-color-white--base {
  color: var(--color-white--base);
}

.u-bg-color-white--base {
  background-color: var(--color-white--base);
}

.u-text-color-grey {
  color: var(--color-grey--base);
}

.u-bg-color-grey {
  background-color: var(--color-grey--base);
}

.u-text-color-grey--base {
  color: var(--color-grey--base);
}

.u-bg-color-grey--base {
  background-color: var(--color-grey--base);
}

.u-text-color-grey--dark {
  color: var(--color-grey--dark);
}

.u-bg-color-grey--dark {
  background-color: var(--color-grey--dark);
}

.u-text-color-grey--light {
  color: var(--color-grey--light);
}

.u-bg-color-grey--light {
  background-color: var(--color-grey--light);
}

.u-text-color-grey--x-light {
  color: var(--color-grey--x-light);
}

.u-bg-color-grey--x-light {
  background-color: var(--color-grey--x-light);
}

.u-text-color-black {
  color: var(--color-black--base);
}

.u-bg-color-black {
  background-color: var(--color-black--base);
}

.u-text-color-black--base {
  color: var(--color-black--base);
}

.u-bg-color-black--base {
  background-color: var(--color-black--base);
}

.u-text-color-brand {
  color: var(--color-brand--base);
}

.u-bg-color-brand {
  background-color: var(--color-brand--base);
}

.u-text-color-brand--base {
  color: var(--color-brand--base);
}

.u-bg-color-brand--base {
  background-color: var(--color-brand--base);
}

.u-text-color-brand--accent {
  color: var(--color-brand--accent);
}

.u-bg-color-brand--accent {
  background-color: var(--color-brand--accent);
}

.u-text-color-brand--support {
  color: var(--color-brand--support);
}

.u-bg-color-brand--support {
  background-color: var(--color-brand--support);
}

.u-text-color-status--green {
  color: var(--color-status--green);
}

.u-bg-color-status--green {
  background-color: var(--color-status--green);
}

.u-text-color-status--orange {
  color: var(--color-status--orange);
}

.u-bg-color-status--orange {
  background-color: var(--color-status--orange);
}

.u-text-color-status--yellow {
  color: var(--color-status--yellow);
}

.u-bg-color-status--yellow {
  background-color: var(--color-status--yellow);
}

.u-text-color-status--red {
  color: var(--color-status--red);
}

.u-bg-color-status--red {
  background-color: var(--color-status--red);
}

.u-text-color-status--marked {
  color: var(--color-status--marked);
}

.u-bg-color-status--marked {
  background-color: var(--color-status--marked);
}

.u-text-color-nav {
  color: var(--color-nav--base);
}

.u-bg-color-nav {
  background-color: var(--color-nav--base);
}

.u-text-color-nav--base {
  color: var(--color-nav--base);
}

.u-bg-color-nav--base {
  background-color: var(--color-nav--base);
}

.u-text-color-nav--hover {
  color: var(--color-nav--hover);
}

.u-bg-color-nav--hover {
  background-color: var(--color-nav--hover);
}

.u-text-color-gradient1--from {
  color: var(--color-gradient1--from);
}

.u-bg-color-gradient1--from {
  background-color: var(--color-gradient1--from);
}

.u-text-color-gradient1--to {
  color: var(--color-gradient1--to);
}

.u-bg-color-gradient1--to {
  background-color: var(--color-gradient1--to);
}

.u-text-color-gradient2--from {
  color: var(--color-gradient2--from);
}

.u-bg-color-gradient2--from {
  background-color: var(--color-gradient2--from);
}

.u-text-color-gradient2--to {
  color: var(--color-gradient2--to);
}

.u-bg-color-gradient2--to {
  background-color: var(--color-gradient2--to);
}

.u-text-color-gradient3--from {
  color: var(--color-gradient3--from);
}

.u-bg-color-gradient3--from {
  background-color: var(--color-gradient3--from);
}

.u-text-color-gradient3--to {
  color: var(--color-gradient3--to);
}

.u-bg-color-gradient3--to {
  background-color: var(--color-gradient3--to);
}

.u-gradient1 {
  background: var(--color-gradient1--from);
  background: linear-gradient(to bottom, var(--color-gradient1--from) 0%, var(--color-gradient1--to) 100%);
}

.u-gradient1--inverse {
  background: var(--color-gradient1--to);
  background: linear-gradient(to bottom, var(--color-gradient1--to) 0%, var(--color-gradient1--from) 100%);
}

.u-gradient1--ltr {
  background: var(--color-gradient1--from);
  background: linear-gradient(to right, var(--color-gradient1--from) 0%, var(--color-gradient1--to) 100%);
}

.u-gradient1--rtl {
  background: var(--color-gradient1--to);
  background: linear-gradient(to right, var(--color-gradient1--to) 0%, var(--color-gradient1--from) 100%);
}

.u-gradient2 {
  background: var(--color-gradient2--from);
  background: linear-gradient(to bottom, var(--color-gradient2--from) 0%, var(--color-gradient2--to) 100%);
}

.u-gradient2--inverse {
  background: var(--color-gradient2--to);
  background: linear-gradient(to bottom, var(--color-gradient2--to) 0%, var(--color-gradient2--from) 100%);
}

.u-gradient2--ltr {
  background: var(--color-gradient2--from);
  background: linear-gradient(to right, var(--color-gradient2--from) 0%, var(--color-gradient2--to) 100%);
}

.u-gradient2--rtl {
  background: var(--color-gradient2--to);
  background: linear-gradient(to right, var(--color-gradient2--to) 0%, var(--color-gradient2--from) 100%);
}

.u-gradient3 {
  background: var(--color-gradient3--from);
  background: linear-gradient(to bottom, var(--color-gradient3--from) 0%, var(--color-gradient3--to) 100%);
}

.u-gradient3--inverse {
  background: var(--color-gradient3--to);
  background: linear-gradient(to bottom, var(--color-gradient3--to) 0%, var(--color-gradient3--from) 100%);
}

.u-gradient3--ltr {
  background: var(--color-gradient3--from);
  background: linear-gradient(to right, var(--color-gradient3--from) 0%, var(--color-gradient3--to) 100%);
}

.u-gradient3--rtl {
  background: var(--color-gradient3--to);
  background: linear-gradient(to right, var(--color-gradient3--to) 0%, var(--color-gradient3--from) 100%);
}

.u-1\\/1 {
  width: 100% !important;
}

.u-1\\/2 {
  flex: none !important;
  width: 50% !important;
}

.u-2\\/2 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/3 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-2\\/3 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-3\\/3 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/4 {
  flex: none !important;
  width: 25% !important;
}

.u-2\\/4 {
  flex: none !important;
  width: 50% !important;
}

.u-3\\/4 {
  flex: none !important;
  width: 75% !important;
}

.u-4\\/4 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/5 {
  flex: none !important;
  width: 20% !important;
}

.u-2\\/5 {
  flex: none !important;
  width: 40% !important;
}

.u-3\\/5 {
  flex: none !important;
  width: 60% !important;
}

.u-4\\/5 {
  flex: none !important;
  width: 80% !important;
}

.u-5\\/5 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/10 {
  flex: none !important;
  width: 10% !important;
}

.u-2\\/10 {
  flex: none !important;
  width: 20% !important;
}

.u-3\\/10 {
  flex: none !important;
  width: 30% !important;
}

.u-4\\/10 {
  flex: none !important;
  width: 40% !important;
}

.u-5\\/10 {
  flex: none !important;
  width: 50% !important;
}

.u-6\\/10 {
  flex: none !important;
  width: 60% !important;
}

.u-7\\/10 {
  flex: none !important;
  width: 70% !important;
}

.u-8\\/10 {
  flex: none !important;
  width: 80% !important;
}

.u-9\\/10 {
  flex: none !important;
  width: 90% !important;
}

.u-10\\/10 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/24 {
  flex: none !important;
  width: 4.16667% !important;
}

.u-2\\/24 {
  flex: none !important;
  width: 8.33333% !important;
}

.u-3\\/24 {
  flex: none !important;
  width: 12.5% !important;
}

.u-4\\/24 {
  flex: none !important;
  width: 16.6667% !important;
}

.u-5\\/24 {
  flex: none !important;
  width: 20.8333% !important;
}

.u-6\\/24 {
  flex: none !important;
  width: 25% !important;
}

.u-7\\/24 {
  flex: none !important;
  width: 29.1667% !important;
}

.u-8\\/24 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-9\\/24 {
  flex: none !important;
  width: 37.5% !important;
}

.u-10\\/24 {
  flex: none !important;
  width: 41.6667% !important;
}

.u-11\\/24 {
  flex: none !important;
  width: 45.8333% !important;
}

.u-12\\/24 {
  flex: none !important;
  width: 50% !important;
}

.u-13\\/24 {
  flex: none !important;
  width: 54.1667% !important;
}

.u-14\\/24 {
  flex: none !important;
  width: 58.3333% !important;
}

.u-15\\/24 {
  flex: none !important;
  width: 62.5% !important;
}

.u-16\\/24 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-17\\/24 {
  flex: none !important;
  width: 70.8333% !important;
}

.u-18\\/24 {
  flex: none !important;
  width: 75% !important;
}

.u-19\\/24 {
  flex: none !important;
  width: 79.1667% !important;
}

.u-20\\/24 {
  flex: none !important;
  width: 83.3333% !important;
}

.u-21\\/24 {
  flex: none !important;
  width: 87.5% !important;
}

.u-22\\/24 {
  flex: none !important;
  width: 91.6667% !important;
}

.u-23\\/24 {
  flex: none !important;
  width: 95.8333% !important;
}

.u-24\\/24 {
  flex: none !important;
  width: 100% !important;
}

@media screen and (width <= 46.9375em) {
  .u-1\\/1\\(s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-1\\/1\\(m\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(m\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(m\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(m\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(m\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(m\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(m\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(m\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(m\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(m\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(m\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(m\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(m\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(m\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(m\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(m\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(m\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(m\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(m\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(m\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(m\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(m\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(m\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em), print {
  .u-1\\/1\\(\\!s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-1\\/1\\(\\!l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 75em), print {
  .u-1\\/1\\(l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-1\\/1\\(xl\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(xl\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(xl\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(xl\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(xl\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(xl\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(xl\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(xl\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(xl\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(xl\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(xl\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(xl\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(xl\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(xl\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(xl\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(xl\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(xl\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(xl\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(xl\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(xl\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(xl\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(xl\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(xl\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }
}

.u-display--inline {
  display: inline !important;
}

.u-display--inline-block {
  display: inline-block !important;
}

.u-display--block {
  display: block !important;
}

.u-display--flex {
  display: flex !important;
}

.u-display--inline-flex {
  display: inline-flex !important;
}

.u-display--none {
  display: none !important;
}

@media screen and (width <= 46.9375em) {
  .u-display--inline\\(s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(s\\) {
    display: block !important;
  }

  .u-display--flex\\(s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(s\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-display--inline\\(m\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(m\\) {
    display: inline-block !important;
  }

  .u-display--block\\(m\\) {
    display: block !important;
  }

  .u-display--flex\\(m\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(m\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(m\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em), print {
  .u-display--inline\\(\\!s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!s\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!s\\) {
    display: none !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-display--inline\\(\\!l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!l\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!l\\) {
    display: none !important;
  }
}

@media screen and (width >= 75em), print {
  .u-display--inline\\(l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(l\\) {
    display: block !important;
  }

  .u-display--flex\\(l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(l\\) {
    display: none !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-display--inline\\(xl\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(xl\\) {
    display: inline-block !important;
  }

  .u-display--block\\(xl\\) {
    display: block !important;
  }

  .u-display--flex\\(xl\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(xl\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(xl\\) {
    display: none !important;
  }
}

.u-display--flow-root {
  display: flow-root !important;
}

.u-position--absolute {
  position: absolute !important;
}

.u-position--relative {
  position: relative !important;
}

.u-position--fixed {
  position: fixed !important;
}

.u-position--static {
  position: static !important;
}

.u-text-align--left {
  text-align: left !important;
}

.u-text-align--right {
  text-align: right !important;
}

.u-text-align--center {
  text-align: center !important;
}

@media screen and (width <= 46.9375em) {
  .u-text-align--left\\(s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(s\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-text-align--left\\(m\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(m\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(m\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em), print {
  .u-text-align--left\\(\\!s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!s\\) {
    text-align: center !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-text-align--left\\(\\!l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 75em), print {
  .u-text-align--left\\(l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-text-align--left\\(xl\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(xl\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(xl\\) {
    text-align: center !important;
  }
}

.u-font-weight--normal {
  font-weight: normal !important;
}

.u-font-weight--bold {
  font-weight: bold !important;
}

.u-font-style--normal {
  font-style: normal !important;
}

.u-font-style--italic {
  font-style: italic !important;
}

.u-text-decoration--underline {
  text-decoration: underline !important;
}

.u-text-decoration--line-through {
  text-decoration: line-through !important;
}

.u-text-decoration--none {
  text-decoration: none !important;
}

.u-border--none {
  border: none !important;
}

.u-border-color--inherit {
  border-color: inherit !important;
}

.u-line-height--normal {
  line-height: normal !important;
}

.u-white-space--nowrap {
  white-space: nowrap !important;
}

.u-white-space--normal {
  white-space: normal !important;
}

@media screen and (width <= 46.9375em) {
  .u-white-space--nowrap\\(s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 47em), print {
  .u-white-space--nowrap\\(\\!s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(\\!s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 75em), print {
  .u-white-space--nowrap\\(l\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(l\\) {
    white-space: normal !important;
  }
}

.u-opacity--0 {
  opacity: 0 !important;
}

.u-opacity--25 {
  opacity: .25 !important;
}

.u-opacity--50 {
  opacity: .5 !important;
}

.u-opacity--75 {
  opacity: .75 !important;
}

.u-opacity--90 {
  opacity: .9 !important;
}

.u-cursor--pointer {
  cursor: pointer !important;
}

.u-cursor--default {
  cursor: default !important;
}

.u-visibility--hidden {
  visibility: hidden !important;
}

.u-overflow--hidden {
  overflow: hidden !important;
}

.u-margin-left--auto {
  margin-left: auto !important;
}

@media screen and (width >= 47em), print {
  .u-margin-left--auto\\(\\!s\\) {
    margin-left: auto !important;
  }
}

.u-width--auto {
  width: auto !important;
}

.u-flex-wrap--nowrap {
  flex-wrap: nowrap !important;
}

.u-flex-wrap--wrap {
  flex-wrap: wrap !important;
}

@media screen and (width <= 46.9375em) {
  .u-flex-wrap--nowrap\\(s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(m\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(m\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em), print {
  .u-flex-wrap--nowrap\\(\\!s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(\\!l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 75em), print {
  .u-flex-wrap--nowrap\\(l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-flex-wrap--nowrap\\(xl\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(xl\\) {
    flex-wrap: wrap !important;
  }
}

.u-order---1 {
  order: -1 !important;
}

.u-order--1 {
  order: 1 !important;
}

@media screen and (width <= 46.9375em) {
  .u-order---1\\(s\\) {
    order: -1 !important;
  }

  .u-order--1\\(s\\) {
    order: 1 !important;
  }
}

@media screen and (width >= 47em), print {
  .u-order---1\\(\\!s\\) {
    order: -1 !important;
  }

  .u-order--1\\(\\!s\\) {
    order: 1 !important;
  }
}

.u-size-xl {
  font-size: var(--font-size-xl);
  line-height: var(--line-height-xl);
}

.u-size-l {
  font-size: var(--font-size-l);
  line-height: var(--line-height-l);
}

.u-size-m {
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
}

.u-size-s {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
}

.u-size-xs {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

.u-size-h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
  font-style: italic;
  font-weight: bold;
}

.u-size-h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
  font-style: italic;
  font-weight: bold;
}

.u-size-h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  font-style: italic;
  font-weight: bold;
}

.u-size-h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
  font-weight: bold;
}

.u-size-h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
  font-weight: bold;
}

.u-size-h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  font-weight: bold;
}

@media screen and (width <= 46.9375em) {
  .u-size-xl\\(s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-size-xl\\(m\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(m\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(m\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(m\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(m\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(m\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(m\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(m\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(m\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(m\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(m\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em), print {
  .u-size-xl\\(\\!s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width <= 74.9375em) {
  .u-size-xl\\(\\!l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 75em), print {
  .u-size-xl\\(l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 90.0625em) {
  .u-size-xl\\(xl\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(xl\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(xl\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(xl\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(xl\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(xl\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(xl\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(xl\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(xl\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(xl\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(xl\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

.u-text-decoration--dashed-underline {
  text-underline-offset: .2rem;
  text-decoration-line: underline;
  text-decoration-style: dashed;
  text-decoration-thickness: from-font;
}

.u-text-decoration--none\\(hover\\):hover {
  text-decoration: none;
}

.c-rating-wrapper {
  max-width: 330px;
}

.c-rating-item--title {
  align-self: center;
}

.c-rating-item--value {
  padding: var(--spacing);
}

.c-rating-total {
  z-index: 1;
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  text-align: center;
  width: 3.8rem;
  height: 3.8rem;
  color: var(--color-white);
  line-height: 3.8rem;
  display: inline-block;
  position: relative;
}

@media screen and (width <= 46.9375em) {
  .c-rating-total {
    width: 3.3rem;
    height: 3.3rem;
    line-height: 3.3rem;
  }
}

.c-rating-total:not(.c-rating-total--transparent):after {
  content: "";
  z-index: -1;
  border-radius: var(--border-radius-xl);
  background-color: var(--color-gradient2--from);
  position: absolute;
  inset: 15%;
}

.c-rating-total__svg {
  color: var(--color-gradient2--from);
  z-index: -1;
  display: block;
  position: absolute;
  inset: 0;
}

.c-rating-total__svg svg {
  width: 100%;
  height: 100%;
  display: block;
}

.c-rating-total--tab {
  width: 3.8rem;
  height: 3.8rem;
  line-height: 3.8rem;
}

.c-rating-circle {
  border-radius: var(--border-radius-xl);
  text-align: center;
  width: 2.6rem;
  height: 2.6rem;
  color: var(--color-brand--support);
  background-color: var(--color-white);
  border: 2px solid;
  line-height: 2.4rem;
  display: inline-block;
}
`;